import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { authAPI } from '@/api/new-api'

export const ActivityTypeEnum = z.enum([
  'reservation',
  'guest',
  'maintenance',
  'post',
  'note',
  'package',
])
export type ActivityType = z.infer<typeof ActivityTypeEnum>

export type ClientActivity = {
  id: string | number
  historyType: ActivityType
  createdAt: number
  updatedAt: number | null
  date?: number
  endDate?: number
  startTime?: number
  endTime?: number
  amenityId?: { name: string; multiDayBooking?: boolean }
  name?: string
  signature?: boolean
  status?: string
  approved?: boolean
  cancelled?: boolean
}

type GetClientActivitiesRequest = {
  clientId: string
}

export const getClientActivitiesQueryKey = (data: GetClientActivitiesRequest) => [
  'useGetClientActivities',
  data,
]

const getClientActivities = async ({ clientId }: GetClientActivitiesRequest) => {
  const response = await authAPI.get<ClientActivity[]>(
    `/client/${clientId}/history/0/9999?type=allActivities`,
  )
  return response.data
}

export const useGetClientActivities = (data: GetClientActivitiesRequest) =>
  useQuery({
    queryFn: () => getClientActivities(data),
    queryKey: getClientActivitiesQueryKey(data),
  })
